import { useRoute } from 'vue-router'

import { getASOHistoricalDataRule, getMarketHistoricalDataRule } from '@/rules/component-access'
import maDate from '@/base/MaDate'
import { PRODUCT_FAMILY } from '@/base/constants/authorization'
import { useFetchUserProductsQuery } from '@/api/services/account'
import { evaluateAsyncSectionAccess } from './section-access'

export function useHistoricalDataAccess() {
  const route = useRoute()

  async function checkHistoricalDataAccess(date, productFamily = route.meta?.productFamily) {
    if (!date)
      return false

    const today = maDate()
    const start = maDate(date)
    const diffDays = Math.abs(today.diff(start, 'days'))

    const ruleMap = {
      [PRODUCT_FAMILY.ASO]: getASOHistoricalDataRule(diffDays),
      [PRODUCT_FAMILY.MARKET]: getMarketHistoricalDataRule(diffDays),
    }

    const ruleFunction = ruleMap[productFamily]

    if (!ruleFunction) {
      return true
    }

    return await evaluateAsyncSectionAccess(ruleFunction)
  }

  return {
    checkHistoricalDataAccess,
  }
}

export function usePendingDowngrade() {
  const { data } = useFetchUserProductsQuery({
    options: {
      select: res => res?.pendingDowngrade,
    },
  })

  return data
}
